<script>
  import Navbar from "./navbar.svelte";
  import { onMount } from "svelte";
  const endpoint = "https://iptv-org.github.io/api/streams.json";
  let posts = [];

  onMount(async function () {
    const response = await fetch(endpoint);
    //console.log(response.ok);

    const data = await response.json();
    posts = data;
  });
  
  function sliceit(t1) {
    return t1.slice(0, -3);
  }

  export let location = null;

  import Grid from "gridjs-svelte"

	import { html } from "gridjs";  

const columns = [
  {
    name: 'Name',
    sort: false,
    formatter: (cell) => html(`<b class="d-inline-block text-truncate">${cell}</b>`)
  },
  {
    name: 'Link',
    sort: false,
    formatter: (cell) => html(`<a href="intent:${cell}#Intent;package=com.mxtech.videoplayer.ad;S.title=OpenIPTV;b.decode_mode=4;end" class="btn btn-primary" style="max-width: 150px;">Play</a>`)
  },
  {
    name: 'Watch',
    sort: false,
    formatter: (cell) => html(`<input class="form-control" value = "${cell}" style="max-width: auto;"></input>`)
  },
]

</script>

<Navbar />
<main class="container pt-5">

  <section class="py-5">
    <div class="container px-5">
        <h1 class="fw-bolder fs-5 mb-4">Channels : </h1>

        <div class="card border-0 shadow rounded-3 overflow-hidden">
            <div class="card-body p-0">
                
              <Grid
                {columns}
                search
                pagination={{ enabled: true, limit: 20 }}
                server={{
                  url: 'https://iptv-org.github.io/api/streams.json',
                  then: data => data.map(channel => {
                    return [channel.channel, channel.url , channel.url]
                  })
                }}
              />

            </div>
        </div>
    </div>
</section>
</main>

<style global>
  @import "https://cdn.jsdelivr.net/npm/gridjs/dist/theme/mermaid.min.css";
</style>